import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LeagueWeek } from '../../../models/LeagueWeek';
import { Player } from '../../../models/Player';
import { GolfEventService } from '../../../services/golf-event.service';
import { NgFor } from '@angular/common';

@Component({
  selector: 'app-weekly-round-list',
  standalone: true,
  imports: [NgFor],
  templateUrl: './weekly-round-list.component.html',
  styleUrl: './weekly-round-list.component.css'
})
export class WeeklyRoundListComponent implements OnChanges {
  @Input() leagueWeek:LeagueWeek|null = null;

  constructor(private golfEventService:GolfEventService) {}

  players:Array<Player> = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['leagueWeek'] && changes['leagueWeek'].currentValue) {
      // session changed
      //this.fetchData(changes['leagueWeek'].currentValue);
      this.getPlayers();
    }
  }

  async getPlayers(){
    if(!this.leagueWeek) return;
    //this.players = await this.golfEventService.getPlayersByEventId(this.leagueWeek.golfEventId);
  }
}

